import styled from "styled-components";

import { CategoryListStyledProps as Props } from "./CategoryList.types";

const CategoryListStyled = styled.div<Props>`
  margin: 1rem 0;
  background-color: var(--palette-white);
  box-shadow: 0 0.4rem 4rem var(--palette-gray-s0-l20-a04),
    0 0.4rem 1.6rem var(--palette-gray-s0-l20-a08);
  width: 100%;
  max-width: 23.2rem;
  border-radius: 0.8rem;

  .CategoryList {
    &__title {
      font-size: 1.2rem;
      font-weight: 400;
      padding: 2.4rem 1.2rem;
      color: var(--palette-gray-s0-l35);
      font-family: inherit;
    }

    &__item {
      padding: 0.4rem 1.2rem;
      margin-bottom: 1.6rem;
      font-size: 1.6rem;
      font-weight: 700;
      color: var(--palette-black-s0-l10);
      width: 100%;
      position: relative;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      justify-content: flex-start;
      display: block;

      &--active {
        color: var(--palette-primary);

        &::before {
          content: "";
          height: 100%;
          width: 0.24rem;
          position: absolute;
          left: 0;
          top: 0;
          background-color: var(--palette-primary);
          border-radius: 2rem;
        }
      }
    }
  }

  .CommonPlaceholder {
    padding-left: 1.6rem;
    padding-top: 0rem;

    &__left {
      display: none;
    }
  }
`;
export default CategoryListStyled;
